// extracted by mini-css-extract-plugin
export default {"backLink":"PageHeader_backLink__zn4c1"};